<template>
  <lazy-table v-model="purchases" model="purchases" ref="table" :params="query">
    <table class="table table-hover table-responsive w-100 d-block d-md-table index-table">
      <thead>
        <tr>
          <sortable-th v-model="sort" sort_key="created_at">{{ 'time' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="description">{{ 'description' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="quantity">{{ 'quantity' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="unit_price">{{ 'unit_price' | t }}</sortable-th>
          <th>{{ 'total' | t }}</th>
          <th>{{ 'is_billed' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="purchase in purchases">
          <td>{{ purchase.created_at | datetime }}</td>
          <td>{{ purchase.description }}</td>
          <td>{{ purchase.quantity }}</td>
          <td>{{ purchase.unit_price }}</td>
          <td>{{ (purchase.unit_price * purchase.quantity) | currency }} {{ customer.currency }}</td>
          <td>{{ purchase.is_billed ? 'yes' : 'no' }}</td>
          <td><i class="fa fa-trash clickable" @click="destroy(purchase)" v-if="!purchase.is_billed"></i></td>
        </tr>
      </tbody>
    </table>
  </lazy-table>
</template>
<script>
import Api from '@/store/jsonapi';
export default {
  props: ['customer'],
  data: function () {
    return {
      purchases: [],
      sort: '-created_at'
    };
  },
  methods: {
    destroy: function (purchase) {
      Api.destroy('purchases', purchase.id).then((d) => {
        this.$refs.table.load(true, true);
      });
    }
  },
  computed: {
    query() {
      return {
        sort: this.sort,
        filter: { customer_id: this.customer.id }
      };
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    },
    query() {
      this.$refs.table.load_debounce(true);
    }
  }
};
</script>

<style scoped>
.index-table td {
  max-width: 110px;
}
</style>
